import type {
  Map as MlMap,
  LayerSpecification,
  GeoJSONSource,
} from 'maplibre-gl';
import type { StructureCollection } from '../api/models';

export const STRUCTURES_SOURCE = 'structures';

// Built hosts render flat and neutral — the totem is the structure
// (docs/game-design/STRUCTURE-GRAPHICS.md); details live in the click details
// panel, so there are no always-on name labels.
const BUILT_HOST_COLOR = '#B3A488';

// structureLayerDefs returns the built-structure host layers: a flat neutral
// fill and outline over the footprint source. Pure so the set can be
// unit-tested.
export function structureLayerDefs(): LayerSpecification[] {
  return [
    {
      id: 'structures-fill',
      type: 'fill',
      source: STRUCTURES_SOURCE,
      paint: { 'fill-color': BUILT_HOST_COLOR, 'fill-opacity': 0.5 },
    },
    {
      id: 'structures-line',
      type: 'line',
      source: STRUCTURES_SOURCE,
      paint: { 'line-color': BUILT_HOST_COLOR, 'line-width': 1 },
    },
  ] as LayerSpecification[];
}

// addStructuresLayer adds (or refreshes) the built-structure footprint source
// and its layers. The totems layer renders the structures themselves on top.
export function addStructuresLayer(map: MlMap, data: StructureCollection): void {
  const footprints = map.getSource(STRUCTURES_SOURCE) as GeoJSONSource | undefined;
  if (footprints) {
    footprints.setData(data);
    return;
  }
  map.addSource(STRUCTURES_SOURCE, { type: 'geojson', data });
  for (const layer of structureLayerDefs()) {
    map.addLayer(layer);
  }
}
